<template>
  <MediaGrid
    ref="grid"
    :results="results"
    :lazy="lazy"
    :show-status="showStatus"
  >
    <template #item-extra="{ isOpen }">
      <div v-b-tooltip title="Edit" @click.prevent="onEdit($event, isOpen)" class="pointer">
        <IconPencil class="fill-color"/>
      </div>
    </template>
    <template #default="{ item }">
      <MediaEdit
        v-if="view === 'edit'"
        :value="item"
        @success="onSuccess"
        @cancel="view = null"
      />
      <MediaQuick v-else :item="item" :show-status="showStatus">
        <template #info>
          <button type="button"
            class="btn btn-primary"
            @click="view = 'edit'"
          >Edit</button>
        </template>
        <template #image-sibling>
          <MediaQuickControls
            @close="$refs.grid.onEscape"
            @previous="$refs.grid.onLeft"
            @next="$refs.grid.onRight"
          />
        </template>
      </MediaQuick>
    </template>
  </MediaGrid>
</template>

<script>
import IconPencil from '@primer/octicons/build/svg/pencil-16.svg'

import MediaGrid from '@/components/MediaGrid.vue'
import MediaEdit from '@/components/MediaEdit.vue'
import MediaQuick from '@/components/MediaQuick.vue'
import MediaQuickControls from '@/components/MediaQuickControls.vue'
import { http } from '@/services/http.js'

export default {
  name: 'MediaGridToggle',
  components: {
    MediaGrid,
    MediaEdit,
    MediaQuick,
    MediaQuickControls,
    IconPencil,
  },
  props: {
    results: Array,
    lazy: null,
    showStatus: null,
  },
  data() {
    return {
      view: null,
    }
  },
  methods: {
    onEdit($event, isOpen) {
      if (isOpen && this.view !== 'edit') {
        $event.stopPropagation()
      }
      this.view = 'edit'
    },
    onSuccess(item, oldItem) {
      this.view = null
      this.replaceItem(item)
      this.$bvToast.toast('Image updated', {title: item.title, variant: 'success'})
      if (oldItem.image) {
        this.$set(item, '_processing', true)
        pollForUpdate(item)
          .then(response => this.replaceItem(response.data))
          .catch(() => this.$set(item, '_processing', 'Timed out'))
      }
    },
    replaceItem(item) {
      const index = this.results.findIndex(i => i.id === item.id)
      this.results.splice(index, 1, item)
    },
  },
}

export async function pollForUpdate(item, duration = 5000, max = 30000, start = Date.now()) {
  await delay(duration)
  const response = await http.get(`/api/images/${item.id}/`)
  if (response.data.updated !== item.updated) {
    return response
  } else if (Date.now() - start < max - duration) {
    return pollForUpdate(item, duration, max, start)
  } else {
    throw new Error('Polling reached time limit')
  }
}

function delay(duration) {
  return new Promise(resolve => setTimeout(resolve, duration))
}
</script>
